import { Avatar } from "primereact/avatar";
import MeaLink from "../../../components/MeaLink";

const MeaStudentAvatar = ({
  student,
  permission,
  schoolId,
  trainingId,
  link = "students",
  noNavigation = false,
  onClick,
}) => {
  const studentName =
    student?.member?.name ||
    (student?.lastname || student?.member?.lastname || "") +
    " " +
    (student?.firstname || student?.member?.firstname || "");

  const avatar = (
    <Avatar
      className="mr-2 p-overlay-badge"
      icon="pi pi-user"
      shape="circle"
      image={
        student?.member?.avatar
          ? student?.member?.avatar + "?u=" + student?.member?.updated_at
          : ""
      }
      label={
        student?.member?.lastname
          ? Array.from(student?.member?.lastname)[0] +
          (student?.member?.firstname
            ? Array.from(student?.member?.firstname)[0]
            : "")
          : student?.member?.name
            ? Array.from(student?.member?.name)[0]
            : ""
      }
      size="normal"
    ></Avatar>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className="p-link inline-flex align-items-center text-left text-primary hover:underline"
        style={{ font: "inherit" }}
        onClick={() => onClick(student)}
      >
        {avatar}
        <span>{studentName}</span>
      </button>
    );
  }

  return (
    <MeaLink
      to={
        link === "candidates"
          ? "/school/" + schoolId + "/admin/registrations/" + trainingId + "/" + link + "/" + student?.id
          : "/school/" + schoolId + "/admin/trainings/" + trainingId + "/" + link + "/" + student?.id
      }
      permission={permission}
      noNavigation={noNavigation}
    >
      {avatar}
      <span>{studentName}</span>
    </MeaLink>
  );
};
export default MeaStudentAvatar;
